module.exports = __webpack_public_path__ + "img/img-fail-connect.d52d6d17.png";